import React from "react";
import PropTypes from "prop-types";
import { Route, withRouter, Switch, Redirect } from "react-router-dom";
import { connect } from "react-redux";

import AppLayout from "../../layout/AppLayout";
import staff from "./staff";

const App = props => {
  const { match } = props;
  return (
    <AppLayout>
      <Switch>
        <Route path={`${match.url}/staff`} component={staff} />
        <Redirect from={`${match.url}/`} to={`${match.url}/staff`} />
        <Redirect to="/error" />
      </Switch>
    </AppLayout>
  );
};

App.defaultProps = {
  match: {}
};
App.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  match: PropTypes.object
};

const mapStateToProps = ({ menu }) => {
  const { containerClassnames } = menu;
  return { containerClassnames };
};

export default withRouter(
  connect(
    mapStateToProps,
    {}
  )(App)
);
